import type { StaticEntityType } from "@/config";
import { EmbeddedPreview } from "@library/components";
import { VIDEO_META } from "../constants";
import type { VideoProps } from "../types";

export const Preview = ({
  entity,
  isVisible,
}: {
  entity: StaticEntityType;
  isVisible: boolean;
}) => {
  const { settings } = entity as StaticEntityType<VideoProps>;
  let {
    metaImage = "",
    metaDescription = "",
    metaTitle = "",
    metaIcon = "",
    metaSiteName = "",
    metaDomain = "",
    src,
    type,
  } = settings;

  const defaultMeta = VIDEO_META[type];

  if (defaultMeta) {
    if (!metaTitle) metaTitle = settings.src;
    if (!metaIcon) metaIcon = defaultMeta.favicon;
    if (!metaImage) metaImage = defaultMeta.favicon;
    if (!metaDomain) metaDomain = defaultMeta.domain;
  }
  return (
    <EmbeddedPreview
      payload={{
        metaTitle,
        metaDescription,
        metaIcon,
        metaSiteName,
        metaDomain,
        metaImage,
        src,
      }}
      isVisible={isVisible}
    />
  );
};
